import React from 'react';
import { PDFViewer, Page, Text, View, Document, StyleSheet, Font, Svg, Polygon, Line } from 'react-pdf-renderer-v2';
import TSLeaveForm from "components/Forms/TSLeaveForm";

Font.register({
    family: 'thsarabun',
    src: 'https://e.trangskin.go.th/thsarabun.ttf'
});

Font.register({
    family: 'thsarabunbold',
    src: 'https://e.trangskin.go.th/thsarabunbold.ttf'
});

const styles = StyleSheet.create({
    page: { backgroundColor: 'tomato' },
    section: { color: 'white', textAlign: 'center', margin: 30 },
    text: { fontFamily: 'thsarabun'}
    
  });

const styles2 = StyleSheet.create({
    body: {
        paddingTop: 20,
        paddingBottom: 20,
        paddingHorizontal: 30,
    },
    title: {
        fontSize: 22,
        textAlign: 'center',
        fontFamily: 'thsarabunbold',
    },
    author: {
        fontSize: 16,
        textAlign: 'right',
        fontFamily: 'thsarabun'
    },
    subtitle: {
        fontSize: 16,
        margin: 5,
        fontFamily: 'thsarabunbold',
    },
    subtitle2: {
        fontSize: 16,
        margin: 5,
        fontFamily: 'thsarabun',
    },
    textBold: {
        marginLeft: 5,
        marginTop: 2,
        marginBottom: 1,
        fontSize: 16,
        textAlign: 'justify',
        fontFamily: 'thsarabunbold',
    },
    text: {
        marginLeft: 5,
        marginTop: 2,
        marginBottom: 1,
        fontSize: 16,
        textAlign: 'justify',
        fontFamily: 'thsarabun',
    },
    text14: {
        fontSize: 14,
        textAlign: 'justify',
        fontFamily: 'thsarabun'
    },
    textCenter: {
        fontSize: 16,
        textAlign: 'center',
        fontFamily: 'thsarabun'
    },
    image: {
        marginVertical: 15,
        marginHorizontal: 100,
    },
    header: {
        fontSize: 12,
        marginBottom: 20,
        textAlign: 'center',
        color: 'grey',
        fontFamily: 'thsarabun'
    },
    pageNumber: {
        position: 'absolute',
        fontSize: 12,
        bottom: 30,
        left: 0,
        right: 0,
        textAlign: 'center',
        color: 'grey',
    },

    row: {
        flex: 1,
        flexDirection: 'row',
        flexGrow: 1,
        marginTop: 10,
    },
    left: {
        // width: '33%',//<- working alternative
        flexGrow: 1,
        flexShrink: 1,
        padding: 5,
        flex: 1,
    },
    right: {
        // width: '66%', //<- working alternative
        flexShrink: 1,
        flexGrow: 1,
        padding: 5,
        flex: 1,
    },
    table: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0
    },
    tableRow: {
        margin: "auto",
        flexDirection: "row"
    },
    tableCol: {
        width: "25%",
        borderStyle: "solid",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
    },
    tableColMerge: {
        width: "100%",
        borderStyle: "solid",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
    },
    tableCell: {

        marginTop: 5,
        fontSize: 16,
        textAlign: 'center',
        fontFamily: 'thsarabun'
    },
    checkbox: {
        height: 21,
        width: 31,
        display: 'inline-block',
        marginTop: -3,
        marginRight: -15
    },
    box: {
        points: "5,10 15,10 15,20 5,20",
        stroke: "black",
        strokeWidth: 1,
    },



});

// Create Document Component
const MyDocument = (props) => {

    const _leaveRequestID = props.LeaveRequestID;
    return (
        <TSLeaveForm LeaveRequestID={_leaveRequestID} />
    );
}
        
export default MyDocument;